import { gql } from "@apollo/client"

export const GET_LOCATION = gql`
query GetLocation ($id:UUID!){
  location (id:$id) {
    id
    name
    streetLineOne
    streetLineTwo
    city
    state
    country
    postalCode
    customFields{
      id
      name
      type
      description
      required
    }
    totalStudents
    totalStaff
  }
}`;